import { IconProps } from './icons-props';

function SharpCrownIcon({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M13.9165 16.4416H6.0832C5.46653 16.4416 4.84153 15.9999 4.6332 15.4249L1.1832 5.76657C0.758198 4.5499 1.06653 3.99157 1.39986 3.74157C1.7332 3.49157 2.3582 3.34157 3.4082 4.09157L6.6582 6.41657C6.7582 6.4749 6.84986 6.4999 6.91653 6.48324C6.99153 6.45824 7.04986 6.39157 7.09153 6.2749L8.5582 2.36657C8.99986 1.1999 9.64986 1.0249 9.99986 1.0249C10.3499 1.0249 10.9999 1.1999 11.4415 2.36657L12.9082 6.2749C12.9499 6.38324 13.0082 6.45824 13.0832 6.48324C13.1582 6.50824 13.2499 6.48324 13.3415 6.40824L16.3915 4.23324C17.5082 3.43324 18.1582 3.59157 18.5165 3.8499C18.8665 4.11657 19.1915 4.70824 18.7332 5.9999L15.3665 15.4249C15.1582 15.9999 14.5332 16.4416 13.9165 16.4416ZM2.2332 4.84157C2.24986 4.95824 2.2832 5.1249 2.36653 5.34157L5.81653 14.9999C5.84986 15.0832 5.99986 15.1916 6.0832 15.1916H13.9165C14.0082 15.1916 14.1582 15.0832 14.1832 14.9999L17.5499 5.58324C17.6665 5.26657 17.6999 5.0499 17.7082 4.9249C17.5832 4.96657 17.3915 5.05824 17.1165 5.25824L14.0665 7.43324C13.6499 7.7249 13.1582 7.81657 12.7165 7.68324C12.2749 7.5499 11.9165 7.1999 11.7332 6.7249L10.2665 2.81657C10.1582 2.5249 10.0582 2.38324 9.99986 2.31657C9.94153 2.38324 9.84153 2.5249 9.7332 2.80824L8.26653 6.71657C8.09153 7.19157 7.7332 7.54157 7.2832 7.6749C6.84153 7.80824 6.34153 7.71657 5.9332 7.4249L2.6832 5.0999C2.49153 4.96657 2.34153 4.88324 2.2332 4.84157Z'
                fill='currentColor'
            />
            <path
                d='M14.5832 18.9583H5.4165C5.07484 18.9583 4.7915 18.6749 4.7915 18.3333C4.7915 17.9916 5.07484 17.7083 5.4165 17.7083H14.5832C14.9248 17.7083 15.2082 17.9916 15.2082 18.3333C15.2082 18.6749 14.9248 18.9583 14.5832 18.9583Z'
                fill='currentColor'
            />
            <path
                d='M12.0832 12.2917H7.9165C7.57484 12.2917 7.2915 12.0084 7.2915 11.6667C7.2915 11.3251 7.57484 11.0417 7.9165 11.0417H12.0832C12.4248 11.0417 12.7082 11.3251 12.7082 11.6667C12.7082 12.0084 12.4248 12.2917 12.0832 12.2917Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default SharpCrownIcon;

